import html2canvas from "html2canvas-pro";

// Capture the current viewport as a PNG Blob. html2canvas-pro is used (not html2canvas)
// because it handles oklch() colors. Browser-only — exercised via E2E, not unit tests.
export async function captureViewport(): Promise<Blob> {
  const canvas = await html2canvas(document.body, {
    x: window.scrollX,
    y: window.scrollY,
    width: window.innerWidth,
    height: window.innerHeight,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    useCORS: true,
    backgroundColor: null,
    // Exclude the widget from the clone instead of hiding it live - hiding
    // the host during capture made the whole UI blink on every submit. The
    // draw canvas is excluded too and composited manually below - canvas
    // cloning support is not worth depending on.
    ignoreElements: (el) =>
      el.hasAttribute("data-previewloop") ||
      el.hasAttribute("data-pl-draw") ||
      el.hasAttribute("data-pl-draw-ghost"),
  });
  const drawCanvas = document.querySelector<HTMLCanvasElement>("[data-pl-draw]");
  if (drawCanvas) {
    canvas.getContext("2d")?.drawImage(drawCanvas, 0, 0, canvas.width, canvas.height);
  }
  return await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error("PreviewLoop: screenshot toBlob failed"))),
      "image/png",
    );
  });
}
